module.exports = __webpack_public_path__ + "img/betflix-support.f1724019.webp";